import TopNotification from './TopNotification';
import './TopNotification.scss';

export default TopNotification;
